import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FlipitemtabService } from '@services/flipitemtab.service';
import { ItemService } from '@services/item.service';
import { MessageService } from '@services/message.service';
import { NotificationService } from '@services/notification.service';
import { RoleManagementService } from '@services/role.management.service';
import { TestService } from '@services/test.service';
import { Subject, Subscription } from 'rxjs';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-item-settings',
  templateUrl: './item-settings.component.html',
  styleUrls: ['./item-settings.component.scss']
})
export class ItemSettingsComponent implements OnInit, OnChanges {
  @Input() isPublished = false;
  @Input() itemId: any;
  @Input() testId: any;

  selectLevels: any;
  selectStatus: any = [];
  collectionId: any;
  collectionUUID: any;
  selectedLevelID: any;
  itemStatusId: any;
  shuffle = false;
  cid: any;
  defaultStatus: any;
  defaultLevel: any;
  isPublishedStatus: any;
  isUnpublishedStatus: any;
  itemIds: any = [];
  itemJsonData: any = [];
  itemBankId: any;
  testId1: any;
  routeSubscription: Subscription;
  itemStatusList: any = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(private itemService: ItemService, private testService: TestService,
    private flipitemtabService: FlipitemtabService, private messageService: MessageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private notificationServices: NotificationService,
    private dialog: MatDialog,
    public roleSer: RoleManagementService,
    private webErrorService: WebErrorService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.collectionUUID = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    if (this.testId) {
      sessionStorage.setItem('TestId', this.testId)
    }

    this.translate.stream('items.statusArray').pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
      this.itemStatusList = translation;
    });
  }

  ngOnChanges() {
    this.itemService.getDifficultyLevel().subscribe((getLevel) => {
      this.selectLevels = getLevel?.items;
      this.selectLevels.sort(function (a, b) { return a.difficultyLevelId - b.difficultyLevelId });
      // this.selectedLevelID = this.selectLevels[0]?.difficultyLevelId;  // By default it is showing difficultylevel 1
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });

    this.itemService.getItemStatus().subscribe((getStatus) => {
      this.selectStatus = getStatus?.items;
      // this.defaultStatus = getStatus?.items[1]?.itemstatus;  // By default it is showing Unpublished status
      this.itemStatusId = getStatus?.items[1]?.itemStatusId;
      this.isPublishedStatus = getStatus?.items[0]?.itemStatusId;
      this.isUnpublishedStatus = getStatus?.items[1]?.itemStatusId;
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });

    if (this.itemId != undefined) {
      this.itemService.getItemDetails(this.itemId).subscribe(resData => {
        this.selectedLevelID = resData?.data?.difficultylevelId;
        this.defaultStatus = resData?.data?.statusId;
        this.shuffle = resData?.data?.shuffle;
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    }
  }

  saveSettings() {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      this.itemService.AddItemSetting(this.itemId, this.selectedLevelID, this.itemStatusId, this.shuffle, this.collectionUUID).subscribe((resData) => {
        // if (this.testId) {
        //   return;
        // } else {
        //   this.notificationServices.success(resData?.message);
        // }
        this.notificationServices.success(resData?.message);
        this.selectStatus?.forEach((statusData: any) => {
          if (resData?.data?.statusId == statusData?.itemStatusId) {
            this.defaultStatus = statusData?.itemStatusId
          }
        });
        this.selectedLevelID = resData?.data?.difficultylevelId
        if (this.defaultStatus == this.isPublishedStatus) {
          this.isPublished = true;
        } else {
          this.isPublished = false;
        }
        this.itemService.updateItemStatus(this.isPublished);
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
      this.testId = sessionStorage.getItem('TestId');

      if (this.defaultStatus == this.isPublishedStatus) {
        if (this.testId && sessionStorage.getItem('itemCategoryID')) {
          this.router.navigate(['/collections', this.collectionUUID, 'tests', this.testId]);
          this.itemService.getItemStatus().subscribe((getStatus) => {
            this.isPublishedStatus = getStatus?.items[0]?.itemStatus;
          }, (error: any) => {
            this.webErrorService.handleAPIErrors(error);
          });
          const itemID = sessionStorage.getItem('itemuuidId') //this.activatedRoute.snapshot.paramMap.get('id');
          this.itemService.getItemDetails(itemID)?.subscribe(
            (data) => {
              this.itemJsonData = [];
              const itemBankIds = this.itemId;
              this.itemJsonData.push({
                itemBankuuId: itemID,
                itemRenderOrder: 0,
                itemGroupId: sessionStorage.getItem('itemCategoryID'),
              });

              this.testService.addItemToTest1(this.testId, this.itemJsonData)?.subscribe(resData => {
                if (resData?.data?.length > 0) {
                  // sessionStorage.removeItem('itemCategoryID');
                  this.notificationServices.success(resData?.message);
                  this.flipitemtabService.emit<boolean>(false);
                }
              }, (error: any) => {
                this.webErrorService.handleAPIErrors(error, null, true, 'warn');
              });
            }, (error: any) => {
              this.webErrorService.handleAPIErrors(error);
            });
        }
        sessionStorage.removeItem('TestId');
      }
    }

  }

  updateStatus(selectedStatus: any): void {
    let data = this.selectStatus.filter(d => d.itemStatusId === selectedStatus);
    if (data[0].itemStatusId == this.selectStatus[0].itemStatusId) {
      const dialogRef = this.dialog.open(DelMessageComponent, {
        panelClass: 'dialog-container-custom',
        data: {
          message: this.translate.instant('itemDetails.TabSettings.deletePopup.message'),
          buttonText: {
            ok: this.translate.instant('itemDetails.TabSettings.deletePopup.btnYes'),
            cancel: this.translate.instant('itemDetails.TabSettings.deletePopup.btnNo')
          }
        }
      });
      data[0] = this.selectStatus;
      const dialogSubscription = dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.itemStatusId = data[0][0].itemStatusId;
        } else {
          this.defaultStatus = data[0][1].itemStatusId;
        }
        dialogSubscription.unsubscribe();
      });
    } else {
      this.itemStatusId = this.selectStatus[1].itemStatusId
    }
  }
}

  // onChange(value: any) {
  //   if (value.checked == true) {
  //     this.shuffle = true;
  //   } else {
  //     this.shuffle = false;
  //   }
  // }
